import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import LoadingContainer from 'App/components/LoadingContainer/LoadingContainer'
import { PERSON_SCHOOL_ROLES } from 'graphql/queries'
import UserContext from 'stores/UserStore'

import { canChangeSchoolRoles, graphqlClient, POSITION_CLASS_STATUS_ID } from 'utils'
import { ROUTES } from 'utils/constants'

import SchoolDataRoleSelectionView from './SchoolDataRoleSelectionView'

const LoadUserSchoolRoles = () => {
  const userStore = useContext(UserContext)
  const currentSchool = userStore.getCurrentSchool()
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  const getPersonSchoolRoles = async () => {
    try {
      const { data } = await graphqlClient().query({
        query: PERSON_SCHOOL_ROLES,
        variables: {
          schoolId: currentSchool && +currentSchool.id,
          positionClassStatusId: POSITION_CLASS_STATUS_ID,
        },
        fetchPolicy: 'no-cache',
      })

      setData(data)
    } catch (e) {
      setError(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getPersonSchoolRoles()
  }, [])

  if (
    !canChangeSchoolRoles({
      byIntegration: currentSchool?.byIntegration,
      schoolBrands: currentSchool?.brands,
      userExternalReference: userStore?.externalReference,
    })
  ) {
    window.PLURALL_ELO_TOAST_CONTAINER.addToast({
      variant: 'negative',
      text: 'Edição de dados escolares indisponível devido a integração automática, procure a escola para a alteração dos dados.',
      seconds: 10,
    })

    navigate(ROUTES.PERFIL_DADOS_ESCOLARES)
  }

  if (error) {
    window.PLURALL_ELO_TOAST_CONTAINER.addToast({
      variant: 'negative',
      text: 'Não foi possível carregar os dados da escola. Por favor, aguarde um instante e tente novamente.',
    })
    navigate(ROUTES.PERFIL_DADOS_ESCOLARES)
  }

  if (loading) {
    return <LoadingContainer fullscreen />
  }

  const { roles } = data.person

  return <SchoolDataRoleSelectionView currentSchool={currentSchool} filteredSchoolRoles={roles} />
}

export default LoadUserSchoolRoles
